import { Link } from 'react-router-dom'

import { env } from '@/app/env'
import { Label } from '@/shared/ui/primitives'
import { PublicPage } from '@/shared/ui/Chrome'
import { usePageTitle } from '@/shared/lib/pageTitle'

/**
 * The page a stale link lands on. A visitor here was on their way somewhere, so it
 * offers the places people usually mean — install, docs, pricing — rather than an
 * account page that is a sign-in wall for anyone without one.
 */
export function NotFound() {
  usePageTitle('Page not found')
  return (
    <PublicPage>
      <section
        className="shell"
        style={{ display: 'grid', placeItems: 'center', minHeight: '60vh', textAlign: 'center' }}
      >
        <div className="stack" style={{ ['--gap' as string]: 'var(--s4)', alignItems: 'center' }}>
          <Label index="404">Not found</Label>
          <h1 style={{ fontSize: 'clamp(3rem, 10vw, 6rem)' }}>404</h1>
          <p className="lead" style={{ textAlign: 'center' }}>
            That page does not exist. It may have moved, or the link may be stale.
          </p>
          <div className="row" style={{ justifyContent: 'center', gap: 'var(--s3)', flexWrap: 'wrap' }}>
            <Link to="/docs/install" className="cta cta--primary">
              Install free →
            </Link>
            <Link to="/docs" className="cta">
              Documentation
            </Link>
            <Link to="/pricing" className="cta">
              Pricing
            </Link>
            <Link to="/" className="cta">
              Home
            </Link>
          </div>
          <p className="mono-note" style={{ textAlign: 'center' }}>
            If a link on our site sent you here, tell us at <code>{env.supportEmail}</code> and we
            will fix it.
          </p>
        </div>
      </section>
    </PublicPage>
  )
}
